var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.513,
    x2: 254.932,
    y1: 253.201,
    y2: 492.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    stopColor: "#632d8c",
    stopOpacity: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5953,
    stopColor: "#5b2d81",
    stopOpacity: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8785,
    stopColor: "#4d2d6e",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452d63"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.773,
    x2: 46.536,
    xlinkHref: "#lg1",
    y1: 478.731,
    y2: 429.097
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.462,
    x2: 179.382,
    xlinkHref: "#lg1",
    y1: 430.927,
    y2: 395.847
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.434,
    x2: 314.434,
    xlinkHref: "#lg1",
    y1: 378.554,
    y2: 414.812
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.811,
    x2: 246.978,
    xlinkHref: "#lg1",
    y1: 476.526,
    y2: 433.646
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.56,
    x2: 97.902,
    xlinkHref: "#lg1",
    y1: 276.652,
    y2: 306.994
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -294.402,
    x2: -96.855,
    xlinkHref: "#lg2",
    y1: 173.112,
    y2: 370.66
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3782,
    stopColor: "#6a516a",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8244,
    stopColor: "#5f435d",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -271.409,
    x2: -115.481,
    xlinkHref: "#lg3",
    y1: 196.105,
    y2: 352.033
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -69.648 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -335.895,
    x2: -179.967,
    xlinkHref: "#lg3",
    y1: 260.591,
    y2: 416.519
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -185.266,
    x2: -185.266,
    xlinkHref: "#lg2",
    y1: 720.911,
    y2: 696.71
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -254.69,
    x2: -95.971,
    xlinkHref: "#lg2",
    y1: 533.399,
    y2: 533.399
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -191.377,
    x2: -164.954,
    xlinkHref: "#lg2",
    y1: 383.548,
    y2: 458.588
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -154.128,
    x2: -211.847,
    xlinkHref: "#lg2",
    y1: 527.273,
    y2: 527.273
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -121.713,
    x2: -199.412,
    xlinkHref: "#lg3",
    y1: 589.805,
    y2: 512.107
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.707 .707 -.707 .707 682.714 71.54)",
    gradientUnits: "userSpaceOnUse",
    x1: -192.455,
    x2: -178.869,
    y1: 519.063,
    y2: 532.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m196.134 510h-135.373c-17.449 0-33.038-10.416-39.715-26.536-6.677-16.121-3.02-34.509 9.318-46.847l13.779-13.779c6.977-6.977 18.289-6.977 25.267 0 6.977 6.978 6.977 18.29 0 25.267l-13.779 13.779c-2.982 2.982-2.265 6.233-1.573 7.905.693 1.672 2.485 4.478 6.702 4.478h135.373c23.543 0 44.918-9.449 60.534-24.758h-9.892c-32.656 0-63.358-12.717-86.449-35.808l-98.116-98.116c-23.091-23.091-35.808-53.793-35.808-86.449v-80.293c0-9.867 7.999-17.866 17.866-17.866s17.866 7.999 17.866 17.866v80.293c0 23.112 9 44.84 25.342 61.182l98.116 98.116c16.342 16.342 38.07 25.342 61.182 25.342h31.881c2.599-8.22 4.001-16.966 4.001-26.034 0-34.058 27.709-61.767 61.767-61.767h1.011c34.058 0 61.767 27.708 61.767 61.767s-27.709 61.767-61.767 61.767h-43.825c-21.255 36.166-60.577 60.491-105.475 60.491zm119.468-96.223h29.835c14.355 0 26.034-11.679 26.034-26.034s-11.679-26.034-26.034-26.034h-1.011c-14.355 0-26.034 11.679-26.034 26.034 0 8.932-.963 17.641-2.79 26.034z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.058 469.789c-.692-1.672-1.409-4.923 1.573-7.905l13.779-13.779c6.977-6.978 6.977-18.29 0-25.267-6.978-6.977-18.29-6.977-25.267 0l-13.779 13.779c-12.338 12.338-15.996 30.726-9.318 46.847 2.712 6.547 6.894 12.153 12.073 16.503l25.886-25.886c-2.975-.648-4.359-2.874-4.947-4.292z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.327 413.701c19.846 19.846 45.317 32.02 72.816 35.052v-36.054c-17.931-2.822-34.468-11.183-47.549-24.265l-7.965-7.965-25.267 25.267z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.425 325.976c-34.058 0-61.767 27.708-61.767 61.767 0 9.068-1.402 17.814-4.001 26.034h36.944c1.828-8.393 2.79-17.101 2.79-26.034 0-14.355 11.679-26.034 26.034-26.034h1.011c1.631 0 3.225.158 4.774.446v-35.977c-1.578-.121-3.166-.203-4.774-.203h-1.011z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.134 474.267h-14.548v35.733h14.548c44.898 0 84.219-24.325 105.478-60.491h-44.944c-15.616 15.309-36.99 24.758-60.534 24.758z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.061 259.02c5.308 21.226 16.279 40.694 32.15 56.566l23.534 23.534 25.267-25.267-23.534-23.534c-16.342-16.342-25.342-38.07-25.342-61.182v-2.191z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 352.131,
    cy: 140.117,
    fill: "url(#SVGID_7_)",
    r: 140.117
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.221 189.207c-54.719 54.719-121.056 77.099-148.167 49.987-27.112-27.112-4.732-93.449 49.987-148.167s121.056-77.099 148.167-49.987 4.732 93.448-49.987 148.167z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.041 189.207c54.719 54.719 121.056 77.099 148.167 49.987s4.732-93.449-49.987-148.167-121.056-77.1-148.167-49.988-4.732 93.449 49.987 148.168z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60.118 455.953-23.823-23.823c-6.778-6.778-6.778-17.767 0-24.545l10.829-10.829 48.368 48.368-10.829 10.829c-6.778 6.778-17.767 6.778-24.545 0z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.589 450.104-42.445-42.445c-10.516-10.516-11.888-26.555-3.133-36.635l191.135-220.062 111.14 111.14-220.062 191.135c-10.08 8.755-26.119 7.383-36.635-3.133z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.954 211.053 103.241 103.241 47.196-13.922c17.436-5.143 23.017-27.069 10.163-39.923l-106.756-106.755c-12.854-12.854-34.78-7.272-39.923 10.163z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.027 348.839-14.619-14.619c-4.635-4.635-4.635-12.15 0-16.784l39.525-39.525c4.635-4.635 12.15-4.635 16.784 0l14.619 14.619c4.635 4.635 4.635 12.15 0 16.784l-39.525 39.525c-4.634 4.635-12.149 4.635-16.784 0z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.006 386.548v-71.465c.339-3.118-.681-6.355-3.071-8.746l-9.024-9.024c-4.186-4.186-10.974-4.186-15.16 0l-6.497 6.497c-2.39 2.39-3.41 5.628-3.071 8.746v105.974z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.277 327.994-9.024-9.024c-4.186-4.186-4.186-10.974 0-15.16l6.497-6.497c4.186-4.186 10.974-4.186 15.16 0l9.024 9.024c4.186 4.186 4.186 10.974 0 15.16l-6.497 6.497c-4.186 4.187-10.973 4.187-15.16 0z",
    fill: "url(#SVGID_15_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.254df2778672f738b84b3fe3b0ffcec1.svg";
export { ForwardRef as ReactComponent };